export { AlfaIdBannerMobile } from './alfaid-banner-mobile';
